import { cardOrderUrlPrefix, routerPaths } from '@epi-constants/routerPaths';
import { Location } from 'history';

export function isLocationWithMenu(location: Location<unknown>): boolean {
  return (
    (!location.pathname.includes(`/${cardOrderUrlPrefix}/`) ||
      location.pathname.includes(`/${cardOrderUrlPrefix}/status`)) &&
    !location.pathname.includes(routerPaths.contract)
  );
}
